import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE } from "./api";

function ViewerPage() {
  const token = new URLSearchParams(window.location.search).get("token");
  const [photos, setPhotos] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    axios.get(`${API_BASE}/get_photos.php?token=${token}`).then(res => setPhotos(res.data));
  }, [token]);

  const toggleSelect = id => {
    setSelected(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
  };

  const submit = async () => {
    await axios.post(`${API_BASE}/submit_selection.php`, { token, selected });
    alert("Submitted");
  };

  return (
    <div>
      <h2>Select Photos</h2>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {photos.map(photo => (
          <div key={photo.id} onClick={() => toggleSelect(photo.id)} style={{ border: selected.includes(photo.id) ? '2px solid blue' : '1px solid gray', margin: 5 }}>
            <img src={`${API_BASE}/uploads/${photo.filename}`} alt="" width={100} />
          </div>
        ))}
      </div>
      <button onClick={submit}>Submit Selection</button>
    </div>
  );
}
export default ViewerPage;